/* src/app/admin/states-list/states-list.component.scss */
/*# sourceMappingURL=states-list.component-MLORDKBQ.css.map */
